/* CARVO — carousels: centre on load, dots, and arrows. */
(function () {
  var TRACKS = ['.lp-rel__carousel', '.lp-rev__track', '.lmx__track'];
  var CARDS  = {
    '.lp-rel__carousel': '.lp-rel__card',
    '.lp-rev__track':    '.lp-rev__card',
    '.lmx__track':       '.lmx__card'
  };

  /* Chrome/Safari report RTL scrollLeft as a negative range.
     Probe once so the maths works in both directions. */
  function negativeMode(t) {
    var keep = t.scrollLeft;
    t.scrollLeft = 1;
    var neg = t.scrollLeft === 0;
    t.scrollLeft = keep;
    return neg;
  }

  function maxScroll(t) { return t.scrollWidth - t.clientWidth; }

  function centre(t) {
    var m = maxScroll(t);
    if (m <= 0) return;
    t.scrollLeft = negativeMode(t) ? -(m / 2) : (m / 2);
  }

  function step(t, cards) {
    if (!cards.length) return t.clientWidth * 0.6;
    var w = cards[0].getBoundingClientRect().width;
    var cs = getComputedStyle(t);
    var gap = parseFloat(cs.columnGap || cs.gap || 0) || 12;
    return w + gap;
  }

  function arrows(t, cards) {
    var host = t.parentNode;
    if (!host || host.querySelector('.cv-arrow')) return;
    ['prev', 'next'].forEach(function (dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cv-arrow cv-arrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? '\u05d4\u05e7\u05d5\u05d3\u05dd' : '\u05d4\u05d1\u05d0');
      b.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" ' +
        'stroke-linecap="round" stroke-linejoin="round"><polyline points="' +
        (dir === 'prev' ? '15 18 9 12 15 6' : '9 18 15 12 9 6') + '"/></svg>';
      b.addEventListener('click', function () {
        var d = step(t, cards);
        t.scrollBy({ left: dir === 'prev' ? -d : d, behavior: 'smooth' });
      });
      host.appendChild(b);
    });
    if (getComputedStyle(host).position === 'static') {
      host.style.position = 'relative';
    }
  }

  function dots(t, cards) {
    if (cards.length < 2) return;
    var host = t.parentNode;
    if (host.querySelector('.cv-dots')) return;
    if (host.querySelector('[data-lmx-dots]')) return;

    var wrap = document.createElement('div');
    wrap.className = 'cv-dots';
    cards.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cv-dots__dot';
      b.setAttribute('aria-label', '\u05e4\u05e8\u05d9\u05d8 ' + (i + 1));
      b.addEventListener('click', function () {
        c.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
      wrap.appendChild(b);
    });
    host.insertBefore(wrap, t.nextSibling);

    var btns = wrap.querySelectorAll('.cv-dots__dot');
    var tick = false;
    function sync() {
      var mid = t.getBoundingClientRect().left + t.clientWidth / 2;
      var best = 0, dist = Infinity;
      cards.forEach(function (c, i) {
        var r = c.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - mid);
        if (d < dist) { dist = d; best = i; }
      });
      btns.forEach(function (b, i) { b.classList.toggle('is-active', i === best); });
      tick = false;
    }
    t.addEventListener('scroll', function () {
      if (!tick) { tick = true; requestAnimationFrame(sync); }
    }, { passive: true });
    sync();
  }

  function init() {
    TRACKS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (t) {
        var cards = Array.prototype.slice.call(t.querySelectorAll(CARDS[sel]));
        if (!cards.length) return;
        dots(t, cards);
        arrows(t, cards);
        if (!t.dataset.cvCentred) {
          t.dataset.cvCentred = '1';
          centre(t);
          setTimeout(function () { centre(t); }, 300);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  window.addEventListener('load', init);
})();
